/* eslint-disable import/no-anonymous-default-export */

export default (api) => {
    const getCurrentUser = (token) => {
        return api.get('api/v1/user', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
    };

    return {
        getCurrentUser
    };
};
